import script from "./CardTemplate.vue?vue&type=script&setup=true&lang=js"
export * from "./CardTemplate.vue?vue&type=script&setup=true&lang=js"

import "./CardTemplate.vue?vue&type=style&index=0&id=67f7efd3&lang=scss&scoped=true"

import exportComponent from "/Users/pontiroli/Desktop/Repositories/eni/dist/eni-dist_longform-just-transition-persone/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67f7efd3"]])

export default __exports__